/**
 * get total cost for cart items based on currency key
 * @param {Object} options
 * @param {Object[]} [options.addons]
 * @param {string} options.currency
 * @param {Object[]} options.items
 * @param {Object[]} [options.optionalAddons]
 * @param {Object[]} [options.promos]
 * @return {number}
 */
export const getCartCost = ({ addons, currency, items, optionalAddons, promos }) => {
  return (
    items.reduce((acc, item) => {
      return acc + (item.prices[currency] ?? 0);
    }, 0) +
    (addons?.reduce((acc, addon) => acc + (addon.prices[currency] ?? 0), 0) ?? 0) +
    (optionalAddons
      ?.filter(({ selected }) => selected)
      .reduce((acc, addon) => acc + (addon.prices[currency] ?? 0), 0) ?? 0) -
    (promos
      ?.filter(({ [currency]: value }) => value)
      .reduce((acc, promo) => acc + (promo[currency] ?? 0), 0) ?? 0)
  );
};

/**
 * get display currency for payment option based on value
 * @param  {Object} options
 * @param  {Object} options.paymentOption
 * @param  {number} options.value
 * @return {string}
 */
export const getDisplayCurrency = ({ paymentOption, value }) => {
  return value === 1 && paymentOption.currencySingular
    ? paymentOption.currencySingular
    : paymentOption.currency;
};
